module.exports = __webpack_public_path__ + "static/img/002.764d7e0f.jpg";